"use client";

import * as Dialog from "@radix-ui/react-dialog";
import { Row } from "@/components";
import { Actions, Close } from "@/icons";
import "./InfoModal.scss";

type InfoModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  id?: string;
  title: string;
  text: string;
};

const InfoModal = ({ open, setOpen, id = "", title, text }: InfoModalProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <div className="ui-info-modal">
          <Dialog.Content className="shadow br-x4 ui-info-modal-body" id={id}>
            <div className="bg-lightblue-a03 ui-info-modal-container shadow br-x4">
              <Row p={"x20"} gap="x16">
                <div className="ui-info-modal-icon base-row bg-lightblue-a03">
                  <div className="ui-info-modal-badge-container">
                    <div className="ui-info-modal-badge" />
                  </div>
                  <Row
                    className="ui-info-modal-action-container"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Actions width={24} height={26} color="slate-28" />
                  </Row>
                </div>
                <div className="w-full">
                  <p className="my-x8 fs-5 fw-semibold">{title}</p>
                  <p>{text}</p>
                </div>
                <Close
                  className="cursor-pointer"
                  onClick={() => setOpen(false)}
                  width={32}
                  height={32}
                  color="slate-28"
                />
              </Row>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { InfoModal };
